import { render, staticRenderFns } from "./tc-video-v1.vue?vue&type=template&id=50d2f16a"
import script from "./tc-video-v1.vue?vue&type=script&lang=js"
export * from "./tc-video-v1.vue?vue&type=script&lang=js"
import style0 from "./tc-video-v1.vue?vue&type=style&index=0&id=50d2f16a&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50d2f16a')) {
      api.createRecord('50d2f16a', component.options)
    } else {
      api.reload('50d2f16a', component.options)
    }
    module.hot.accept("./tc-video-v1.vue?vue&type=template&id=50d2f16a", function () {
      api.rerender('50d2f16a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tc-video-v1.vue"
export default component.exports